module.exports = __webpack_public_path__ + "static/media/quote-open.e7aa2f33.png";